import { render, staticRenderFns } from "./Regras.vue?vue&type=template&id=2b723757&scoped=true"
import script from "./Regras.vue?vue&type=script&lang=js"
export * from "./Regras.vue?vue&type=script&lang=js"
import style0 from "./Regras.vue?vue&type=style&index=0&id=2b723757&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b723757",
  null
  
)

export default component.exports